import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ControlledField } from 'src/components/controlled-field';
import { FieldTypes } from 'src/components/controlled-field/types';
import { selectUserLoggedIn } from 'src/store/slices/user-slice';
import { selectIsDualOccupantFlow, selectQueryData } from 'src/store/slices/dual-occupant-slice';

import { userDataKeys } from './constants';
import { styles } from './styles';

import type { UserDetailsProps, UserDataFormValues } from './types';

export const UserDetails: FC<UserDetailsProps<UserDataFormValues>> = ({ control }) => {
    const { t } = useTranslation();
    const userLoggedIn = useSelector(selectUserLoggedIn);
    const isDualOccupantJourney = useSelector(selectIsDualOccupantFlow);
    const dualOccupantData = useSelector(selectQueryData);

    const disableImmutableFields =
        userLoggedIn || (isDualOccupantJourney && dualOccupantData.userEmail !== null);

    return (
        <Box css={styles.userDetailsContainer}>
            <Box css={styles.inputGroupWrapper}>
                <ControlledField
                    name={userDataKeys.firstName}
                    control={control}
                    label={t('your_details_form_first_name_label')}
                    placeholder={t('your_details_form_first_name_placeholder')}
                    type="text"
                    disabled={disableImmutableFields}
                />
                <ControlledField
                    name={userDataKeys.lastName}
                    control={control}
                    type="text"
                    label={t('your_details_form_last_name_label')}
                    placeholder={t('your_details_form_last_name_placeholder')}
                    disabled={disableImmutableFields}
                />
            </Box>
            <ControlledField
                type="text"
                name={userDataKeys.preferredName}
                control={control}
                label={t('your_details_form_preferred_name_label')}
                placeholder={t('your_details_form_preferred_name_placeholder')}
                required={false}
            />
            {userLoggedIn && (
                <ControlledField
                    type="email"
                    name={userDataKeys.email}
                    control={control}
                    label={t('your_details_form_email_label')}
                    placeholder={t('your_details_form_email_placeholder')}
                    disabled
                />
            )}

            <ControlledField
                fieldType={FieldTypes.Phone}
                name={userDataKeys.phone}
                control={control}
                label={t('your_details_form_phone_label')}
            />
            <ControlledField
                fieldType={FieldTypes.DateOfBirth}
                name={userDataKeys.dateOfBirth}
                control={control}
                label={t('your_details_form_date_of_birth_label')}
            />
        </Box>
    );
};
